import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Form, Grid, Header, Modal, Radio, Segment } from 'semantic-ui-react';
import { HasAutoRenewLevel } from '../../containers/Authorization';
import './styles.css';
import { InternationalTerms, USTerms } from './terms';

// eslint-disable-next-line
const terms = `By selecting automatic renewal you understand you are enrolling in AARP automatic membership renewal. Your selected payment method will be charged 12 for your first introductory year. For any subsequent year you participate in the program, your selected payment method will be charged the full annual rate (currently $16) on the first day of the month in which the membership expires. Additionally, you are agreeing to receive digital automatic renewal notices at email addresses you have provided to AARP. Enrollment in AARP automatic renewal can be cancelled at any time by calling 1-800-516-1993.`;

class TermSelector extends Component {
  static propTypes = {
    fieldChangeHandler: PropTypes.func.isRequired,
    member: PropTypes.object,
    subHeader: PropTypes.string,
    allowCCPayments: PropTypes.bool,
    allowECheckPayments: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    if (props.allowCCPayments === false && props.allowECheckPayments === true) {
      delete USTerms[3];
    }
    this.state = {
      showTerms: false,
    };
  }

  onChangeValue = (_, data) => {
    const { fieldChangeHandler } = this.props;

    let term = USTerms.filter(usTerm => usTerm.id === data.value);
    if (term.length === 0) {
      term = InternationalTerms.filter(intlTerm => intlTerm.id === data.value);
    }

    this.setState({
      showTerms: !!term[0].autoRenew,
    });
    fieldChangeHandler(_, data);
  }

  closeModal = () => {
    this.setState({
      showTerms: false,
    });
  }

  render() {
    const { member, subHeader } = this.props;
    const { showTerms } = this.state;
    const displayUS = member.country === '' || member.country === 'US';

    return (
      <React.Fragment>
        <Header as="h3">
          Membership Fee
          <Header.Subheader>
            {subHeader}
          </Header.Subheader>
        </Header>
        <Segment>
          <Grid stackable columns={1}>
            {
              displayUS ?
                <Grid.Column>
                  <Header as="h4">
                    U.S.
                  </Header>
                  {
                    USTerms.map(term => (
                      <React.Fragment key={term.id}>
                        {
                          term.autoRenew &&
                          <HasAutoRenewLevel>
                            <Form.Field>
                              <Radio
                                label={term.label}
                                name="membershipTerm"
                                value={term.id}
                                checked={member.membershipTerm === term.id}
                                onChange={this.onChangeValue}
                              />
                              {
                                term.addlText &&
                                <span> <b>{term.addlText}</b></span>
                              }
                            </Form.Field>
                          </HasAutoRenewLevel>
                        }
                        {
                          !term.autoRenew &&
                          <Form.Field>
                            <Radio
                              label={term.label}
                              name="membershipTerm"
                              value={term.id}
                              checked={member.membershipTerm === term.id}
                              onChange={this.onChangeValue}
                            />
                            {
                              term.addlText &&
                              <span> <b>{term.addlText}</b></span>
                            }
                          </Form.Field>
                        }
                      </React.Fragment>
                    ))
                  }
                </Grid.Column>
                :
                <Grid.Column>
                  <Header as="h4">
                    International
                  </Header>
                  {
                    InternationalTerms.map(term => (
                      <React.Fragment key={term.id}>
                        {
                          term.autoRenew &&
                          <HasAutoRenewLevel>
                            <Form.Field>
                              <Radio
                                label={term.label}
                                name="membershipTerm"
                                value={term.id}
                                checked={member.membershipTerm === term.id}
                                onChange={this.onChangeValue}
                              />
                              {
                                term.addlText &&
                                <span> <b>{term.addlText}</b></span>
                              }
                            </Form.Field>
                          </HasAutoRenewLevel>
                        }
                        {
                          !term.autoRenew &&
                          <Form.Field>
                            <Radio
                              label={term.label}
                              name="membershipTerm"
                              value={term.id}
                              checked={member.membershipTerm === term.id}
                              onChange={this.onChangeValue}
                            />
                            {
                              term.addlText &&
                              <span> <b>{term.addlText}</b></span>
                            }
                          </Form.Field>
                        }
                      </React.Fragment>
                    ))
                  }
                </Grid.Column>
            }
          </Grid>
        </Segment>
        {showTerms &&
          <Modal
            styleName="popUp"
            open={showTerms === true}
            onClose={this.closeModal}
            closeIcon
          >
            <Modal.Header>Terms &amp; Conditions</Modal.Header>
            <Modal.Content>
              <ul>
                <li>AARP will charge your credit card $12 now.</li>
                <li>You will receive a reminder that your membership is about to expire at least 30 days before your membership will automatically renew and</li> {/* eslint-disable-line max-len */}
                <li>Your credit card will be charged the standard annual rate, currently $16, for the next year of membership.</li>
                <li>The standard rate may change in the future but we will notify you in advance.</li>
                <li>You may cancel at any time by calling 1-800-516-1993 or sending an email to <a href="mailto:member@aarp.org">member@aarp.org</a>.</li> {/* eslint-disable-line max-len */}
              </ul>
            </Modal.Content>
            <Modal.Actions>
              <Button
                id="termsOkButton"
                positive
                content="Ok"
                onClick={this.closeModal}
              />
            </Modal.Actions>
          </Modal>
        }
      </React.Fragment>
    );
  }
}

export default TermSelector;



// WEBPACK FOOTER //
// ./src/app/components/Terms/index.js